"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var renderer_1 = require("@react-pdf/renderer");
var luxon_1 = require("luxon");
var React = __importStar(require("react"));
var BCCSeal_1 = __importDefault(require("../BCCSeal"));
var Column_1 = __importDefault(require("../Column"));
var PJLATestingLogo_1 = __importDefault(require("../PJLATestingLogo"));
var Row_1 = __importDefault(require("../Row"));
var style = renderer_1.StyleSheet.create({
    rootContainer: {
        marginHorizontal: 10,
        marginBottom: 5,
        paddingTop: 5,
        position: "absolute",
        bottom: 0,
        left: 0,
        right: 0,
        height: 80,
    },
    textContainer: {
        display: "flex",
        justifyContent: "center",
        flexGrow: 1,
    },
    text: {
        fontSize: 7,
        fontFamily: "Quicksand",
    },
    bold: {
        fontWeight: 700,
    },
    light: {
        opacity: 0.5,
    },
});
var Footer = function (_a) {
    var sampleId = _a.sampleId, qrCode = _a.qrCode, completedDate = _a.completedDate, _b = _a.companyAddress, companyAddress = _b === void 0 ? "3 Mason Irvine, CA 92618" : _b, _c = _a.companyPhoneNumber, companyPhoneNumber = _c === void 0 ? "(949) 288-5337" : _c, _d = _a.companyWebsite, companyWebsite = _d === void 0 ? "www.think20labs.com" : _d, _e = _a.isoNumber, isoNumber = _e === void 0 ? "104286" : _e, _f = _a.bccLicenseNumber, bccLicenseNumber = _f === void 0 ? "C8-000014-LIC" : _f;
    return (React.createElement(renderer_1.View, { style: style.rootContainer, fixed: true },
        React.createElement(renderer_1.View, { style: {
                position: "absolute",
                left: 0,
                right: 0,
                bottom: 0,
                top: 0,
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
            } },
            React.createElement(renderer_1.Text, { style: [style.text], render: function (_a) {
                    var pageNumber = _a.pageNumber, totalPages = _a.totalPages;
                    return "Page " + pageNumber + " of " + totalPages;
                }, fixed: true })),
        React.createElement(Row_1.default, { style: { flexGrow: 1, alignItems: "center" } },
            !!qrCode && (React.createElement(Column_1.default, null,
                React.createElement(renderer_1.Image, { src: qrCode.url, style: { height: 45, width: 45 } }))),
            React.createElement(Column_1.default, null,
                React.createElement(BCCSeal_1.default, { style: { marginRight: 5, height: 50, width: 44 } })),
            React.createElement(Column_1.default, null,
                React.createElement(PJLATestingLogo_1.default, { style: { marginRight: 5, height: 45, width: 50 } })),
            React.createElement(Column_1.default, { style: style.textContainer },
                React.createElement(renderer_1.Text, { style: [style.text] }, companyAddress),
                React.createElement(renderer_1.Text, { style: [style.text] },
                    "BCC Lic # ",
                    bccLicenseNumber),
                React.createElement(renderer_1.Text, { style: [style.text] },
                    "ISO 17025:2017 # ",
                    isoNumber),
                React.createElement(renderer_1.Text, { style: [style.text] }, companyPhoneNumber),
                React.createElement(renderer_1.Link, { style: [style.text, { textDecoration: "none" }], src: companyWebsite }, companyWebsite)),
            React.createElement(Column_1.default, null),
            React.createElement(Column_1.default, { style: __assign(__assign({}, style.textContainer), { alignItems: "flex-end" }) },
                React.createElement(renderer_1.Text, { style: style.text },
                    "Sample ID: ",
                    React.createElement(renderer_1.Text, { style: [style.text, style.bold] }, sampleId)),
                React.createElement(renderer_1.Text, { style: style.text },
                    "Expiration Date:",
                    " ",
                    React.createElement(renderer_1.Text, { style: [style.text, style.bold] }, luxon_1.DateTime.fromISO(completedDate)
                        .plus(luxon_1.Duration.fromObject({ days: 365 }))
                        .toLocaleString(luxon_1.DateTime.DATE_SHORT))),
                React.createElement(renderer_1.View, { style: { margin: 2 } }))),
        React.createElement(Row_1.default, { style: { flexGrow: 1 } },
            React.createElement(renderer_1.Text, { style: { fontFamily: "Quicksand", fontSize: 4 } }, "All tests were performed with relevant laboratory quality control samples (LQCs) and passed prescribed acceptance criteria according to Barclays Official California Code of Regulations (CCR) section 5730, pursuant to 16 CCR section 5726 (e)(13). Testing results are based on the sample submitted to Think20 Labs LLC in the picture and description above. Think20 Labs LLC affirms that all analytical testing was performed consistent with industry standards and in accordance with validated methods designed and verified by Think20 Labs LLC. All testing results were produced in compliance with applicable state and federal laws. This report may not be reproduced, except in full, without the written approval of Think20 Labs LLC. Abbreviations used: LOQ = Limit of Quantitation; LOD = Limit of Detection; ND = Not Detected, NT = Not Tested; \u00B5g = Microgram; mg = Milligram; mL = Milliliter; g = Gram; kg = Kilogram."))));
};
exports.default = Footer;
//# sourceMappingURL=index.js.map